var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add_dialog",
          attrs: {
            width: "600px",
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色名称:", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "10",
                      placeholder: "请输入角色名称",
                      disabled: ""
                    },
                    model: {
                      value: _vm.form.title,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "角色授权:" } }, [
                _c(
                  "div",
                  { staticClass: "menu_wrapper" },
                  [
                    _c("el-tree", {
                      ref: "tree",
                      attrs: {
                        data: _vm.menuData,
                        "show-checkbox": "",
                        "default-expand-all": "",
                        "node-key": "id",
                        "highlight-current": "",
                        "check-strictly": ""
                      },
                      on: {
                        "check-change": _vm.checkChange,
                        check: _vm.checkClick
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }